<div class="gvc-grid-buttons grid-buttons">
    @for (amount of gridAmounts; track amount) {
        <button type="button" class="btn btn-primary" (mousedown)="fillAmount($event, amount)">+{{ amount }}</button>
    }
</div>
